import React, { useContext, useEffect, useState } from 'react'
import UserContext from '../../../services/context/userContext';
import { getClients, getPendingInvites } from '../../../services/firebase/firestore/getData';
import Loading from '../../_default/Loading';
import SearchPage from '../../_default/SearchPage'
import ActiveClientsList from '../ActiveClientsList';
import "./PendingClients.scss"
import Select from "react-select"
import ExerciseList from '../../_exercises/ExerciseList';
function PendingClients() {
    const user = useContext(UserContext);
    let [clients,setClients]=useState([])
    let [loading,setLoading]=useState(true)
    let [searchClient,setSearchClient]=useState("")
    console.log("coach_id",user.id)
    useEffect(()=>{
      localStorage.removeItem("tabIndex")
        // getClients(user.id,res=>{
        //     console.log("clients",res)
        //     let filter=res.filter((data)=>data.first_name+" "+data.last_name==searchClient)
        //     if(searchClient.length>0){
        //         setClients(filter)
        //         setLoading(false)
        //         console.log("filter clients",filter)
        //     }else{
        //         setClients(res)

        //         setLoading(false)
        //     }
        // })
        getPendingInvites(user.id,res=>{
          console.log("pending client res",res)
          console.log("clients",res)
          res=res.length>0?res:[]
          let filter=res.filter((data)=>data.first_name+" "+data.last_name==searchClient)
          if(searchClient.length>0){
              setClients(filter)
              setLoading(false)
              console.log("filter clients",filter)
          }else{

              setClients(res)

              setLoading(false)
          }
        })

    },[searchClient,loading])

  return (
    <div className='c-page-wrapper c-page-dashboard c-page-exercises' style={{padding:"unset"}}>
    <div className='c-page-wrapper--exercises'>
    <div className="c-page-main--exercises">
          {/* <div className="c-exercise-finder"> */}
            {/* <SearchPage placeholder="Search excercise"   value={searchClient} onChange={(e)=>{setSearchClient(e.target.value)}} /> */}
            <Select options={
              clients.map((data)=>({
                value: data.userID,
                label: data.first_name+" "+data.last_name ,
  
              }))
            } 
            onChange={(e)=>{setSearchClient(e.label)}} 
            placeholder="Search client"
            />
            {/* <div className="c-dropdown-holder">
              <DropDown options={filters} value={filter} onChange={(e) => {setFilter(e); setFilterParam(e)}} />
              <DropDown options={filterTypes} value={filterType} onChange={(e) => {setFilterType(e); setFilterTypeParam(e)}} />
            </div>
          
            </div> */}
            <div style={{marginTop:"5%"}}>
              {
                loading?
                <div style={{marginTop:"5%"}}>
                    <Loading />
                </div>:
              // console.log("pending clients",clients)
            // <ActiveClientsList clients={clients} pending="pending" />
            <ExerciseList loading={loading} setLoading={setLoading} clients={clients} pending="pending" activeClient={true}/>
              }
            </div>
                
          {/* <div className="c-side-options">
            <ul>
              {categories[from] &&
                _initial_categories.map((item, idx) => (
                  <li key={idx}>
                    <div className="checkbox" onClick={() => {handleCheck(item); setParamsCategories(item) }}>
                      <Icon icon={checked.includes(item) ? "checked" : "unchecked"} size={20} height={20} color={checked.includes(item) ? '#00B9A5' : "#979797"} />
                    </div>
                    <p>
                      {item} ({ categories[from].filter((e) => e.category === item)[0].count })
                    </p>
                  </li>
                ))}
              
            
            </ul>
          </div>

          
          {loading ? 
            <div className="c-list-loader">
              <Spinner  size={50}/>
            </div>
           : (
            <ExerciseList history={props.history} from={from} exercises={exercises[from]} removeExercise={(e) => setShowPopup({ type: "exercise", ...e })} />
          )} */}
        </div>

    </div>
    </div>
  )
}

export default PendingClients